import { type LucideIcon } from "lucide-react";
import { Card, useTheme, Box, Typography, SxProps } from "@mui/material";
import { palette } from "@powerdiary/components-library/lib";

interface IInvoicePayDetailProps {
    title: string;
    value: string;
    icon: LucideIcon;
    dataTestIdSuffix: string;
}

const cardStyleSx: SxProps = {
    padding: "8px 16px",
    display: "flex",
    alignItems: "center",
    gap: "14px",
    borderRadius: "4px",
    backgroundColor: palette.neutral["50"],
    borderColor: palette.neutral["50"],
};
export default function InvoicePayDetail({
    title,
    value,
    icon: Icon,
    dataTestIdSuffix,
}: Readonly<IInvoicePayDetailProps>) {
    const { palette: muiPalette } = useTheme();
    return (
        <Card sx={cardStyleSx} data-test-id={`section_invoice_detail_${dataTestIdSuffix}`}>
            <Icon
                color={muiPalette.primary.main}
                size={20}
                strokeWidth={2}
                data-test-id={`icon_invoice_detail_${dataTestIdSuffix}`}
                aria-hidden
            />
            <Box display="flex" flexDirection="column">
                <Typography
                    component="p"
                    variant="paragraphSmallRegular"
                    color={palette.neutral["700"]}
                    data-test-id={`text_invoice_detail_title_${dataTestIdSuffix}`}
                >
                    {title}
                </Typography>
                <Typography
                    variant="paragraphMediumSemiBold"
                    color="textPrimary"
                    lineHeight="15px"
                    data-test-id={`text_invoice_detail_value_${dataTestIdSuffix}`}
                >
                    {value}
                </Typography>
            </Box>
        </Card>
    );
}
